import request from '@/utils/request';
import * as types from '@/api/milestone/types';

// 里程碑详情

export function getMilestonesByIid(params: types.commonMilestoneReqType): Promise<types.commonMilestoneResType> {
  return request({
    url: `/issuepr/api/v1/projects/${params.project_id}/milestone_by_iid/${params.milestone_iid}`,
    method: 'get'
  });
}
